import {
   BillIcon,
   CalendarIcon,
   HomeIcon,
   MarketplaceIcon,
   MyWebpageIcon,
   ProductsIcon,
   ReviewBubbleIcon,
   VerifiedUserIcon,
} from '~/svgs/header';

import { DhamenRequestsIcon } from '~/svgs';
import { Translate } from '~/i18n';
import css from './header/styles.module.css';

type Item = {
   href: string;
   icon: any;
   text: React.ReactNode;
   exact?: boolean;
   needsReview?: boolean;
   description?: React.ReactNode;
   hideInternational?: boolean;
};
export type LinkAttributes = {
   children?: Omit<Item, 'icon'>[];
} & Item;

export type OptionalLinkAttributes = Omit<Item, 'icon'>;

export const links: LinkAttributes[] = [
   {
      href: '/dashboard',
      icon: <HomeIcon className={css.icon} />,
      text: <Translate id="dashboard:dashboard" />,
      exact: true,
   },
   {
      href: '/products',
      icon: <ProductsIcon className={css.icon} />,
      text: <Translate id="common:my products" />,
      needsReview: true,
   },
   {
      href: '/sales-feed',
      icon: <CalendarIcon className={css.icon} />,
      text: <Translate id="dashboard:bookings" />,
      needsReview: true,
   },
   {
      href: '/webpage',
      icon: <MyWebpageIcon className={css.icon} />,
      text: <Translate id="webpage:my webpage" />,
      needsReview: true,
   },
   {
      href: '/marketplace',
      icon: <MarketplaceIcon className={css.icon} />,
      text: <Translate id="marketplace:marketplace" />,
      // needsReview: true,
   },
   {
      href: '/operations/attendees-list',
      icon: <VerifiedUserIcon className={css.icon} />,
      text: <Translate id="common:check in" />,
      needsReview: true,
   },
   {
      href: '/reviews',
      icon: <ReviewBubbleIcon className={css.icon} />,
      text: <Translate id="reviews:reviews" />,
      needsReview: true,
   },
   {
      href: '/orders/payout',
      icon: <BillIcon className={css.icon} />,
      text: <Translate id="common:finance and payout" />,
      needsReview: true,
   },
   // {
   //    href: '/coming-soon',
   //    icon: <ReportsIcon className={css.icon} />,
   //    text: <Translate id="common:reports and instghts" />,
   //    // needsReview: true,
   // },
];

if (process.env.NEXT_PUBLIC_HAS_PRIVATE_ROUTES !== 'true') {
   links.splice(2, 0, {
      href: '/umrah-requests',
      icon: <DhamenRequestsIcon className={css.icon} />,
      text: <Translate id="visasManager:dhamen requests" />,
      needsReview: true,
   });
}

export const international_links: LinkAttributes[] = [
   {
      href: '/marketplace',
      icon: <MarketplaceIcon className={css.icon} />,
      text: <Translate id="marketplace:marketplace" />,
   },
];

export const onboard_links: OptionalLinkAttributes[] = [
   // {
   //    href: '/profile/details',
   //    text: <Translate id="profile:business profile" />,
   //    exact: true,
   // },
   {
      href: '/profile/files',
      text: <Translate id="profile:legal documents" />,
      exact: true,
   },
   // {
   //    href: '/profile/plans',
   //    text: <Translate id="profile:business plans" />,
   //    exact: true,
   // },
   // {
   //    href: '/profile/agreement',
   //    text: <Translate id="profile:agreement" />,
   //    exact: true,
   // },
];

export const marketplace_links: OptionalLinkAttributes[] = [
   {
      href: '/marketplace',
      text: <Translate id="marketplace:search" />,
      description: <Translate id="marketplace:search description" />,
   },
   {
      href: '/marketplace/bookings',
      text: <Translate id="marketplace:my purchases" />,
      description: <Translate id="marketplace:my purchases description" />,
      needsReview: true,
   },
   {
      href: '/marketplace/wallet',
      text: <Translate id="marketplace:my wallet" />,
      description: <Translate id="marketplace:wallet description" />,
      needsReview: true,
   },
];

export const payout_links: OptionalLinkAttributes[] = [
   {
      href: '/orders/payout',
      text: <Translate id="payout:payout requests" />,
      description: <Translate id="payout:payout requests subtitle" />,
   },
   {
      href: '/orders/bank-details',
      text: <Translate id="payout:bank account info title" />,
      description: <Translate id="payout:bank account info subtitle" />,
      needsReview: true,
   },
];
